import styled, { css } from 'styled-components'

type WrapperProps = {
  weight?: 400 | 600
  hasTestTextarea?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, weight = 400, hasTestTextarea }) => css`
    width: 100%;

    textarea {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 140px;
      font-size: 1rem;
      padding: 0.6rem;
      border-radius: ${theme.border.smallRadius};
      background: ${theme.colors.white};
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.normal};
      font-size: ${theme.font.sizes.xxxsmall};
      transition: 0.2s;
      resize: none;
      margin-bottom: 20px;

      ::-webkit-scrollbar {
        width: 4px;
      }

      ::-webkit-scrollbar-thumb {
        background: ${theme.colors.primary};
        border-radius: 8px;
        overflow-y: hidden;
      }

      &::placeholder {
        color: ${theme.colors.xlightGray};
        font-family: ${theme.font.montserrat};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.xxxsmall};
      }

      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }

      ${hasTestTextarea &&
      css`
        height: 59px;
        background: ${theme.colors.xxlightGray};
        border-radius: ${theme.border.radius};
        padding: 1.2rem 0.8rem;

        &::placeholder {
          color: ${theme.colors.black};
        }
      `}
    }

    label {
      display: block;
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${weight};
      line-height: 1;
      margin-top: 1rem;
      margin-left: 6px;
      padding-bottom: 0.3rem;
      color: ${theme.colors.white};
    }

    .error {
      color: ${theme.colors.red};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.bold};
      margin: 0px 0 4px 6px;
    }
  `}
`
